import styled from "styled-components";
import { palette } from "styled-theme";

const LoginTemplateWrapper = styled.div`
  .mobile {
    background: #f4f5f8;
    height: 100vh;
    padding: 30px 20px;

    .mobile-outer-container {
      margin: 0;
      .mobile-lock {
        width: 30px;
        height: 30px;
        background-color: ${palette("primary", 0)};
        position: absolute;
        top: 15px;
        left: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        .icon {
          font-size: 15px;
          color: white;
        }
      }
      .title {
        padding-bottom: 20px;
        h3 {
          margin: 0;
        }
        span {
          display: flex;
        }
      }
    }
    .forgotPassword {
      display: flex;
      padding-top: 20px;
      justify-content: center;
    }
    .firebaseui-container {
      .firebaseui-button {
        background-color: ${palette("primary", 0)};
      }
      .firebaseui-id-secondary-link {
        background-color: transparent !important;
        color: ${palette("primary", 0)};
      }
      .mdl-textfield__label:after {
        background-color: ${palette("primary", 0)};
      }
      .firebaseui-label::after {
        background-color: ${palette("primary", 0)};
      }
    }
  }
  .outer-container {
    height: 100vh;
    align-items: center;
    justify-content: center;
    display: flex;

    .inner-container {
      height: 500px;
      width: 900px;
      padding: 0;
      display: flex;
      flex-direction: column;
      align-items: center;
      border: 1px solid ${palette("border", 0)};
      border-radius: 10px;
      .login-content {
        display: flex;
        height: 100%;
        width: 100%;
      }

      .right-container {
        flex: 1;
        align-items: center;
        display: flex;
        height: 100%;
        width: 100%;
        justify-content: center;
        margin: 0 20px;
        svg {
          margin-top: 8px;
        }
      }
      .left-container {
        // padding: 100px 0;
        align-items: center;
        display: flex;
        justify-content: center;
        /* flex-direction: column;   */
        flex: 1;
        .ant-form-item-explain {
          width: 340px;
        }
        .lock {
          width: 60px;
          height: 60px;
          background-color: ${palette("primary", 0)};
          position: absolute;
          top: calc(50vh - 280px);
          left: calc(50vw - 420px);
          display: flex;
          align-items: center;
          justify-content: center;
          border-radius: 5px;
          .icon {
            font-size: 40px;
            color: white;
          }
        }
        .title {
          padding-bottom: 20px;
          h3 {
            margin: 0;
          }
        }
      }
    }
    .forgotPassword {
      display: flex;
      padding-top: 20px;
    }
    .firebaseui-container {
      .firebaseui-button {
        background-color: ${palette("primary", 0)};
      }
      .firebaseui-id-secondary-link {
        background-color: transparent !important;
        color: ${palette("primary", 0)};
      }
      .mdl-textfield__label:after {
        background-color: ${palette("primary", 0)};
      }
      .firebaseui-label::after {
        background-color: ${palette("primary", 0)};
      }
    }
  }
`;

export default LoginTemplateWrapper;
